// @core/api/endpoints/task/delete_time_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete time entry
 * Deletes a time entry from the task. Users can only delete their own time entries unless they have admin privileges.
 */
export async function DeleteTimeEntry(
  task_id: string,
  entry_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/time/:entry_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  requestPath = requestPath.replace(':entry_id', encodeURIComponent(entry_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
